// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1lDy5","paramInput":"JobSimulator_paramInput__yVHiP","input":"JobSimulator_input__ASua6"};